import { createBrowserRouter } from 'react-router-dom'
import { ConsoleLayout } from '@/app/console-layout'
import { RootLayout } from '@/app/root-layout'
import { RequireAuth, RequireRole } from '@/features/auth/guards'
import { LoginPage } from '@/features/auth/login-page'
import { ConfirmPage } from '@/features/auth/confirm-page'
import { UsersPage } from '@/features/users/users-page'
import { UserDetailPage } from '@/features/users/user-detail-page'
import { PromoBannerPage } from '@/features/promo-banner/promo-banner-page'
import { SponsoredCoinsPage } from '@/features/sponsored-coins/sponsored-coins-page'
import { AppPatchPolicyPage } from '@/features/app-patch-policy/app-patch-policy-page'
import { TrendingPage } from '@/features/trending/trending-page'
import { RewardsPage } from '@/features/rewards/rewards-page'
import { AdminsPage } from '@/features/admins/admins-page'
import { AuditPage } from '@/features/audit/audit-page'
import { QuestsPage } from '@/features/quests/quests-page'
import { MessagesPage } from '@/features/i18n/messages-page'
import { LanguagesPage } from '@/features/i18n/languages-page'
import { ModulesPage } from '@/features/i18n/modules-page'
import { PublishPage } from '@/features/i18n/publish-page'
import { DashboardPage, NotFoundPage } from '@/features/placeholder-pages'

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/confirm', element: <ConfirmPage /> },
      {
        element: <RequireAuth />,
        children: [
          {
            element: <ConsoleLayout />,
            children: [
              { index: true, element: <DashboardPage /> },
              { path: 'users', element: <UsersPage /> },
              // `:id` is a users.public_id, matching the audit log's target_id
              // convention — never the numeric PK, which never leaves the DB.
              { path: 'users/:id', element: <UserDetailPage /> },
              { path: 'quests', element: <QuestsPage /> },
              { path: 'rewards', element: <RewardsPage /> },
              { path: 'promo-banner', element: <PromoBannerPage /> },
              { path: 'sponsored-coins', element: <SponsoredCoinsPage /> },
              { path: 'app-patch-policy', element: <AppPatchPolicyPage /> },
              { path: 'trending', element: <TrendingPage /> },
              { path: 'i18n/messages', element: <MessagesPage /> },
              { path: 'i18n/languages', element: <LanguagesPage /> },
              { path: 'i18n/modules', element: <ModulesPage /> },
              { path: 'i18n/publish', element: <PublishPage /> },
              {
                element: <RequireRole allow={['super']} />,
                children: [
                  { path: 'admins', element: <AdminsPage /> },
                  { path: 'audit', element: <AuditPage /> },
                ],
              },
              { path: '*', element: <NotFoundPage /> },
            ],
          },
        ],
      },
    ],
  },
])
